import { CompanyResponse, TwitterUser } from "./personalization";

export interface TweetsResponse {
  company_twitter: TwitterUser;
  profile_twitter: TwitterUser;
  company: CompanyResponse;
}
